import React from 'react';

const PaymentForm = ({ form, formError, onChange, onSubmit, onCancel, isEdit, students, fees }) => (
  <form onSubmit={onSubmit} className="modal-form">
    <select className="paymentform-student-select" value={form.student} onChange={e=>onChange('student', e.target.value)} required>
      <option value="" disabled>Select Student</option>
      {students && students.map(student => (
        <option key={student._id} value={student._id}>{student.name} - {student.class} {student.section}</option>
      ))}
    </select>
    <select value={form.fee} onChange={e=>onChange('fee', e.target.value)} required>
      <option value="" disabled>Select Fee</option>
      {fees && fees.map(fee => (
        <option key={fee._id} value={fee._id}>{fee.class} {fee.section} - ₹{fee.amount}</option>
      ))}
    </select>
    <input type="number" placeholder="Amount" value={form.amount} onChange={e=>onChange('amount', e.target.value)} required />
    <input type="date" placeholder="Date" value={form.date} onChange={e=>onChange('date', e.target.value)} required />
    <select value={form.method} onChange={e=>onChange('method', e.target.value)} required>
      <option value="" disabled>Payment Method</option>
      <option value="Cash">Cash</option>
      <option value="Card">Card</option>
      <option value="Online">Online</option>
      <option value="Other">Other</option>
    </select>
    <input type="text" placeholder="Receipt Number" value={form.receiptNumber} onChange={e=>onChange('receiptNumber', e.target.value)} required />
    <div className="modal-actions">
      <button type="submit">{isEdit ? 'Save' : 'Add'}</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </div>
    {formError && <div className="error">{formError}</div>}
  </form>
);

export default PaymentForm; 